import { render } from "./Payments.vue?vue&type=template&id=01e923b6&ts=true"
import script from "./Payments.vue?vue&type=script&lang=ts"
export * from "./Payments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__